<template>
  <Dialog ref="dialogRef"/>
  <Loading v-if="isLoading"/>

  <!--퍼블 확인 레이아웃 추가-->
  <div v-if="isPub($route.fullPath)">

    <PublishLayout>
      <template v-slot:default>
        <router-view :key="$route.fullPath"/>
      </template> 
    </PublishLayout>
    
  </div>

  <component :is="$route.meta.layout ? $route.meta.layout : DefaultLayout" v-else>
    <template v-slot:sideMenu>
      <router-view name="sideMenu"/>
    </template>

    <template v-slot:default>
      <router-view :key="$route.fullPath"/>
    </template>

  </component>


</template>

<script setup>
import { provide, ref, onBeforeMount, onBeforeUnmount } from 'vue';
import Dialog from '@/components/common/modal/Dialog.vue'
import Loading from '@/views/Loading.vue'
import { useLoading } from '@/composable/Loading'
import DefaultLayout from '@/layoutPage/DefaultLayout.vue';
import PublishLayout from '@/layoutPage/PublishLayout.vue';
import { useNavigatorStore } from './store/navigator';

const { isLoading } = useLoading()
const navigatorStore = useNavigatorStore()
provide('openDialog',openDialog)

const dialogRef = ref()

function isPub(path){
  if(path.includes('publish')){
    return true
  }
  return false
}

onBeforeMount(() =>{
  navigatorStore.setIsMobile()
  window.addEventListener('resize', navigatorStore.setIsMobile)
  if (localStorage.getItem('layoutData')) {
    localStorage.removeItem('layoutData')
  }
})

onBeforeUnmount(() =>
  window.removeEventListener('resize', navigatorStore.setIsMobile)
)

//dialog open 함수
async function openDialog(type,msg){
    // openDialog 호출하면 return 으로 Promise 객체 return 받음
    const ok = await dialogRef.value.openDialog(type,msg)
    return ok
}



</script>
